import { type ConversationType } from './constants'

const addConversationUnreadToTotal = async ({
  setunreadCountBySid,
  conversation,
}: {
  setunreadCountBySid
  conversation: ConversationType
}) => {
  if (conversation.lastReadMessageIndex === null) {
    const messageCount = await conversation.getMessagesCount()
    setunreadCountBySid((obj) => ({ ...obj, [conversation.sid]: messageCount }))
  } else {
    const unread = await conversation.getUnreadMessagesCount()
    setunreadCountBySid((obj) => ({ ...obj, [conversation.sid]: unread || 0 }))
  }
}

export default addConversationUnreadToTotal
